module.exports = __webpack_public_path__ + "static/img/reward3.908f17f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/reward3.png
// module id = Ds2F
// module chunks = 1 3